import { api } from "./_client";

export async function getLeadColumns() {
    const { data } = await api.get("/leads/columns");
    return data.columns || [];
}

export async function saveLeadColumns(columns) {
    const { data } = await api.put("/leads/columns", { columns });
    return data.columns || [];
}

export async function listLeads() {
    const { data } = await api.get("/leads");
    return data;
}

export async function createLead(cells = {}) {
    const { data } = await api.post("/leads", { cells });
    return data;
}

export async function updateLead(id, payload) {
    const { data } = await api.patch(`/leads/${id}`, payload);
    return data;
}

export async function deleteLead(id) {
    const { data } = await api.delete(`/leads/${id}`);
    return data;
}

export async function convertLead(id, payload) {
    const { data } = await api.post(`/leads/${id}/convert`, payload);
    return data;
}

// iter-184 — Create a contact from a lead (mirror action).
export async function createContactFromLead(leadId) {
    const { data } = await api.post(`/leads/${leadId}/create-contact`);
    return data; // { contact, created }
}

// iter-185 — Bulk convert multiple leads to contacts in one call.
export async function bulkCreateContactsFromLeads(leadIds) {
    const { data } = await api.post("/leads/bulk-create-contacts", {
        lead_ids: leadIds,
    });
    return data; // { results, created, linked, skipped }
}

export async function importLeadsXps(file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/leads/import-xps", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

// iter-165 — poll counter for near-real-time cross-teammate sync.
export async function getLeadsStateVersion() {
    const { data } = await api.get("/leads/state-version");
    return data;
}

// iter-166 — Live cursor chips: heartbeat while typing + snapshot of
// who else is typing right now (grouped by lead_id).
export async function heartbeatLeadTyping(leadId) {
    const { data } = await api.post(`/leads/${leadId}/typing`);
    return data;
}
export async function getLeadsTypingState() {
    const { data } = await api.get("/leads/typing-state");
    return data;
}

// ----- Plugins (iter-40) -----
